var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonRisingFilledLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.22 6.03l2.53-1.94L14.56 4L13.5 1l-1.06 3l-3.19.09l2.53 1.94l-.91 3.06l2.63-1.81l2.63 1.81z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "lineMdMoonRisingFilledLoop0",
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "0.7s;lineMdMoonRisingFilledLoop0.begin+6s",
    dur: "0.4s",
    values: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+2.2s",
    dur: "0.4s",
    values: "1;0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 5.25L15.25 4l-2.06-.05L12.5 2l-.69 1.95L9.75 4l1.64 1.25l-.59 1.98l1.7-1.17l1.7 1.17z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+3s",
    dur: "0.4s",
    values: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+5.2s",
    dur: "0.4s",
    values: "1;0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.61 12.25L21.25 11l-2.06-.05L18.5 9l-.69 1.95l-2.06.05l1.64 1.25l-.59 1.98l1.7-1.17l1.7 1.17z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+0.4s",
    dur: "0.4s",
    values: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+2.8s",
    dur: "0.4s",
    values: "1;0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.828 9.731l1.876-1.439l-2.366-.067L19.552 6l-.786 2.225l-2.366.067l1.876 1.439L17.601 12l1.951-1.342L21.503 12z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+3.4s",
    dur: "0.4s",
    values: "0;1"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "lineMdMoonRisingFilledLoop0.begin+5.6s",
    dur: "0.4s",
    values: "1;0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 6 C7 12.08 11.92 17 18 17 C18.53 17 19.05 16.96 19.56 16.89 C17.95 19.36 15.17 21 12 21 C7.03 21 3 16.97 3 12 C3 8.83 4.64 6.05 7.11 4.44 C7.04 4.95 7 5.47 7 6 Z",
    transform: "translate(0 22)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    fill: "freeze",
    calcMode: "linear",
    dur: "0.6s",
    path: "M0 0v-22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonRisingFilledLoop);
export default __webpack_public_path__ + "static/media/moon-rising-filled-loop.2c478e6def7afd2882a292f9672416c6.svg";
export { ForwardRef as ReactComponent };